// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__XOnFc","logo":"Loading_logo__q00mL"};